<template>
  <div class="seomain">
    <st-header
      title="审批详情"
      :back-able="true"
    >
    </st-header>
    <div class="aprroving-box">
      <div class="approving-top">
        <span class="approving-title">{{ approverData.sp_name }}</span>
        <span class="approving-status">{{ approverData.status }}</span>
      </div>

      <div class="approving-user">
        <div style="float: left;">
          <img class="user-avatar" :src="approverData.avatar" alt="">
        </div>
        <div class="approving-user-info">
          <p>{{ approverData.applyers }}</p>
          <p>{{ approverData.apply_time }}</p>
        </div>
      </div>
    </div>


    <div class="approve-record-head">审批记录</div>

    <div class="approve-record-box">
      <div class="approve-start-time">{{ approverData.apply_time }}</div>
      <div class="approve-record-line-box">
        <div class="approve-record-line">
          <!-- 审批发起人 -->
          <div class="approve-record-item">
            <div class="approve-record-step-img">
              <img class="user-avatar" src="../../../assets/svg/approver.svg" alt="">
            </div>
            <div class="approver">
              <div class="approved-username"><span class="pri-span">{{ approverData.applyers }}</span></div>
              <div class="approved-date">{{ approverData.apply_time }}</div>
            </div>
          </div>
          <!-- 审批人 -->
          <div class="approve-record-item" v-for="(v, i) in approverData.sp_record" :key="i">
            <div class="approve-record-step-img">
              <img class="user-avatar" src="../../../assets/svg/approving.svg" alt="">
            </div>
            <div class="approved-record">
              <div class="approved-record-top">
                <div class="approved-record-status"><span class="pri-span">{{ v.sp_status }}</span> <span>&emsp;{{ v.approverattr }}</span></div>
                <div class="approved-record-time">{{ v.sptime }}</div>
              </div>
              <hr>
              <div class="approved-user-list">
                <div style="overflow: hidden;" v-for="(vv, ii) in v.details" :key="ii">
                  <div style="float: left;">
                    <img class="user-avatar" :src="vv.avatar.includes('http') ? vv.avatar : (base_url + vv.avatar)" alt="">
                  </div>
                  
                  <div class="approved-user-state">
                    <div class="approved-username">{{ vv.approvers }}</div>
                    <div class="approved-user-status">{{ vv.sp_status }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 抄送人 -->
          <div class="approve-record-item" v-if="approverData.notifyer.length > 0">
            <div class="approve-record-step-img">
              <div class="user-avatar user-avatar-border">
                <img class="user-avatar-img" src="../../../assets/svg/approve-ccto.svg" alt="">
              </div>
            </div>
            <div class="approved-record">
              <div class="approved-record-top">
                <div class="approved-record-status"><span class="pri-span">抄送</span></div>
                <div class="approved-record-time">{{ approverData.apply_time }}</div>
              </div>

              <div class="approved-ccto-user-list">
                <div class="approved-ccto-user-item" v-for="(user, i) in approverData.notifyer" :key="'n' + i">
                  <img class="user-avatar" :src="approverData.avatar" alt="">
                  <div style="text-align: center;">{{user.approvers}}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 结束 -->
          <div class="approve-record-item">
            <div class="approve-record-step-img">
              <div class="user-avatar user-avatar-text">结束</div>
            </div>
            <div class="approved-end">
              <div class="approved-end-text">以上信息来源：企业微信审批流API</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import { BASE_URL } from '@/config/global.js'
import { approval } from "./conf/notSub";

export default {
  components: {
    "st-header": StHeader,
  },
  props: {},
  data() {
    return {
      approverData: {},
      loading: false,
      base_url: BASE_URL,
    };
  },
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加采购订单" });
    });
  },
  mounted() {},
  watch: {},

  methods: {
    init() {
      this.getFlow();
    },

    // 获取审批流程
    getFlow() {
      let params = {
        orderid: this.$route.params.id,
        type: 2
      };

      this.$post(this.$api.stGetApprovalInfo, params).then((res) => {
        if (res.code !== 200) {
          this.$toast.fail(res['msg']) ? res['msg'] : '获取异常';
          return;
        } 

        this.approverData = res.data;
      })

      // this.approverData = approval.data;
    },
    onConfirm() {},
    handleAfterRead() {},
  },
};
</script>

<style lang="scss" scoped>
.user-avatar {
  height: 52px;
  width: 54px;
  border-radius: 27px;
}

.user-avatar-text {
  color: rgba(255, 255, 255, 1);
	background-color: rgba(153, 153, 153, 1);
	font-size: 14px;
  text-align: center;
  line-height: 52px;
}

.user-avatar-border {
  background-color: rgba(121, 72, 234, 1);
  position: relative;
  .user-avatar-img {
    width: 40px;
    height: 36px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.pri-span {
  color: rgba(42, 130, 228, 1);
  font-weight: bold;
}

.aprroving-box{
  margin: 12px 13px;  
  background-color: rgba(255, 255, 255, 1);
  padding: 15px 15px 0px;
  border-radius: 5px;
  .approving-top {
    .approving-title {
      margin: 18px 12px 10px;
      color: rgba(80, 80, 80, 1);
      font-size: 20px;
    }

    .approving-status {
      background-color: rgba(255, 141, 26, 1); 
      color: rgba(255, 255, 255, 1);
      border-radius: 5px;
      font-size: 12px;
      padding: 10px 12px;
    }

  }

  .approving-user {
    margin: 15px 15px 0px;
    overflow: hidden;
    .approving-user-info {
      float: left;
      min-height: 54px;
      margin: 8px 15px;
      line-height: 150%;
    }
  }
}


.approve-record-head {
  margin: 20px 12px 0px 13px;
  padding: 0px 15px;
	color: rgba(80, 80, 80, 1);
	background-color: rgba(238, 246, 246, 1);
	border-radius: 5px;
	font-size: 14px;
	line-height: 51px;
  height: 51px;
	font-weight: bold;
}

.approve-record-box {
  margin: 0px 12px 0px 13px;
	color: rgba(80, 80, 80, 1);
	background-color: rgba(255, 255, 255, 1);
	border-radius: 5px;
	font-size: 14px;
	line-height: 150%;
  position: relative;
  overflow: hidden;
  
  .approve-start-time {
    position: relative;
    width: 154px;
    left: 15px;
    margin-top: 12px;
    padding: 5px 0px;
    color: rgba(255, 255, 255, 1);
    background-color: rgba(212, 48, 48, 1);
    border-radius: 5px;
    font-size: 12px;
    line-height: 150%;
    text-align: center;
  }

  .approve-record-line-box {
    position: relative;

    .approve-record-line {
      position: relative;
      left: 50px;
      border-left: solid rgba(229, 229, 229, 1) 1px;
      padding-top: 15px;

      .approve-record-item {
        position: relative;
        left: -25px;
        padding-top: 10px;
        overflow: hidden;
        margin-bottom: 35px;

        .approve-record-step-img {
          float: left;
        }

        .approver,.approved-record,.approved-end {
          float: left;
          position: relative;
          margin-left: 20px;
          padding: 0px 15px;
          width: 60%;
          min-height: 46px;
          color: rgba(80, 80, 80, 1);
          background-color: rgba(239, 239, 239, 1);
          border-radius: 5px;
          font-size: 14px;
          line-height: 150%;
        }

        .approver {
          .approved-username,.approved-date {
            position: relative;
            top: 50%;
            transform: translateY(50%);
          }
          .approved-username {
            float: left;
          }

          .approved-date {
            float: right;
          }
        }

        .approved-record {
          .approved-record-top {
            position: relative;
            overflow: hidden;
            height: 30px;

            .approved-record-status,.approved-record-time {
              position: relative;
              top: 50%;
              transform: translateY(-50%);
            }
            .approved-record-status {
              float: left;
            }

            .approved-record-time {
              float: right;
            }
          }

          .approved-user-list {
            padding-bottom: 10px;
            overflow: hidden;

            .approved-user-state{
              float: left;
              margin: 5px 15px;
              line-height: 150%;

              .approved-username {
                color: rgba(80, 80, 80, 1);
              }

              .approved-user-status {
                margin-top: 5px;
                padding: 3px 10px;
                color: rgba(255, 255, 255, 1);
                background-color: rgba(255, 141, 26, 1);
                border-radius: 5px;
                font-size: 10px;
                line-height: 150%;
                text-align: center;
              }
            }
          }
 
          .approved-ccto-user-list {
            margin: 20px 0px 0px;

            .approved-ccto-user-item {
              margin-bottom: 10px;
              width: 55px;
              margin-right: 5px;
            }
          }

        }

        .approved-end-text {
          position: relative;
          top: 50%;
          transform: translateY(50%);
        }
      }
    }
  }
}
</style>
